(function() {
  function initDesktopNavigation() {
    var nav = $('.plp-navigation');
    if (!nav.length) return;

    var selectorLast;
    $('.actual-link')
      .off('click.plpNavigation')
      .on('click.plpNavigation', function() {
        var selectorName = '.' + $(this).attr('class').split(' ')[0];
        localStorage.setItem('lastClickedSelector', selectorName);
      });

    if (localStorage.getItem('lastClickedSelector')) {
      nav.find('.active').each(function(i, e) {
        selectorLast = $(e).find(localStorage.getItem('lastClickedSelector'));
        selectorLast.parents('.has-dropdown').addClass('open').find('.submenu:first').show();
      });
      if (selectorLast !== '[object Object]') {
        nav.find('.active:first').parents('.has-dropdown').addClass('open').find('.submenu:first').show();
      }
    } else {
      nav.find('.active:first').parents('.has-dropdown').addClass('open').find('.submenu:first').show();
    }

    nav.find('.selected').each(function() {
      $(this).parents('.has-dropdown').addClass('open').find('.submenu:first').show();
    });

    nav.find('.expandable .actual-link')
      .off('click.plpNavigationToggle')
      .on('click.plpNavigationToggle', function() {
        if ($(this).parent().hasClass('open')) {
          $(this).parent().removeClass('open').find('.submenu:first').hide();
        } else {
          $(this).parent().addClass('open').find('.submenu:first').show();
        }
      });
  }

  function initMobileNavigation() {
    var nav = $('.menu-mobile');
    if (!nav.length) return;

    var selectorLast;
    $('.menu-mobile .parent-link, .menu-mobile .submenu-link')
      .off('click.plpNavigationMobile')
      .on('click.plpNavigationMobile', function() {
        var selectorName = '.' + $(this).attr('class').split(' ')[0];
        var collectionUrl = $(this).closest('.item').data('link') || $(this).data('link');
        localStorage.setItem('lastClickedSelector', selectorName);
        localStorage.setItem('lastCollectionUrl', collectionUrl);
      });

    if (localStorage.getItem('lastClickedSelector')) {
      nav.find('.active').each(function(i, e) {
        selectorLast = $(e).find(localStorage.getItem('lastClickedSelector'));
        selectorLast.parents('.has-dropdown').addClass('open').find('.submenu:first').show();
      });
      if (selectorLast !== '[object Object]') {
        nav.find('.active:first').parents('.has-dropdown').addClass('open').find('.submenu:first').show();
      }
    } else {
      nav.find('.active:first').parents('.has-dropdown').addClass('open').find('.submenu:first').show();
    }

    if (localStorage.getItem('lastCollectionUrl') && document.querySelector('.multi-collection-wrapper')) {
      var itemSaved = localStorage.getItem('lastCollectionUrl');
      var collectionContainers = document.querySelectorAll('.multi-collection-wrapper');
      collectionContainers.forEach(function(container) {
        if (container.dataset.collectionUrl === itemSaved) {
          container.style.display = 'block';
        }
      });
    } else if (document.querySelector('.multi-collection-wrapper')) {
      document.querySelector('.multi-collection-wrapper').style.display = 'block';
    }

    if (document.querySelector('.single-collection-wrapper')) {
      var singleWrapper = document.querySelector('.single-collection-wrapper');
      singleWrapper.style.display = document.querySelector('.single-collection-wrapper .subcats-anchors .flex > *') ? 'block' : 'none';
    }

    nav.find('.selected').each(function() {
      $(this).parents('.has-dropdown').addClass('open').find('.submenu:first').show();
    });
  }

  function initPlpNavigation() {
    if (window.innerWidth > 800) {
      initDesktopNavigation();
    } else {
      initMobileNavigation();
    }
  }

  window.initPlpNavigation = initPlpNavigation;

  $(function() {
    initPlpNavigation();
  });
})();
